import _split from 'lodash/split';
import _some from 'lodash/some';
import _size from 'lodash/size';
import _toInteger from 'lodash/toInteger';
import {
  isValid,
  format,
  differenceInDays,
  addDays,
  isToday,
  parseISO,
} from 'date-fns';

export const splitYear = dateString => _split(dateString, '-')[0];

export const extractDateFromString = dateString => {
  if (!dateString) {
    return {};
  }
  const dateArray = _split(dateString, '-');
  return { y: dateArray[0], m: dateArray[1], d: dateArray[2] };
};

const validateDateInput = (year, month, day) => {
  const yearInt = _toInteger(year);
  const monthInt = _toInteger(month);
  const dayInt = _toInteger(day);
  const isLeapYear = yearInt % 400 === 0 || (yearInt % 100 !== 0 && yearInt % 4 === 0);
  const daysInFeb = isLeapYear ? 29 : 28;
  const DAYS_IN_MONTHS = [31, daysInFeb, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  return monthInt <= 12 && dayInt <= DAYS_IN_MONTHS[monthInt - 1] && dayInt >= 1;
};

export const stringifyDate = date => {
  /*
     The `month - 1` here is because JS date instance 0 indexes months ¯\_(ツ)_/¯
  */

  const [year, month, day] = [date.y, date.m, date.d];
  const isDateInputValid = validateDateInput(year, month, day);
  if (!isDateInputValid) {
    return null;
  }
  const includesSpecialChars = _some([year, month, day], datePart => /[a-zA-Z!@#$%^&*(),.?":{}|<>]/.test(datePart));
  const stringDate = new Date(Date.UTC(year, month - 1, day));
  const isStringDateValid = isValid(stringDate);
  if (!isStringDateValid || includesSpecialChars || _size(year) > 4) {
    return null;
  }
  return stringDate;
};

export const getHumanReadableDate = date => {
  if (!date) {
    return null;
  }
  const dateObject = parseISO(date);
  if (!isValid(dateObject)) {
    return null;
  }
  if (isToday(dateObject)) {
    return format(dateObject, "h:mma 'today'");
  }
  return format(dateObject, "h:mma 'on' EEEE, do 'of' MMMM");
};

export const calculateExampleDate = (min, max) => {
  if (!min || !max) {
    return null;
  }
  const minDate = new Date(min);
  const maxDate = new Date(max);
  const differenceBetweenDates = differenceInDays(maxDate, minDate);
  const threeQuarterDifference = differenceBetweenDates * 0.75;
  const exampleDate = addDays(minDate, threeQuarterDifference);
  return format(exampleDate, 'dd MM yyyy');
};
